import React, { useState, useEffect } from 'react';
import * as S from './styles';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import GtinTable from '../../components/tabelagtin/GtinTable';
import useBuscaClientes from '../../services/Cliente/useBuscaClientes';
import buscaProdutoPorGTIN from '../../services/apiCosmos/BuscaProduto';
import secureStorage from '../../utils/SecureStorage';
import ProdutoService from '../../services/Produto/ProdutoService';

const getProdutoInicial = () => ({
  _id: null,
  gtin: '',
  thumbnail: '',
  description: '',
  price: '',
  avg_price: '',
  max_price: '',
  min_price: '',
  width: '',
  height: '',
  length: '',
  net_weight: '',
  gross_weight: '',
  id_Cliente: [],
  brand: { name: '', picture: '' },
  gpc: { code: '', description: '' },
  ncm: { code: '', description: '', full_description: '' },
  cest: { id: '', code: '', description: '', parent_id: '' },
  gtins: []
});

const ModalCadastroProduto = ({ isOpen, onClose, atualizarLista, produto = null }) => {
  const [produtoState, setProdutoState] = useState(getProdutoInicial());
  const [tabIndex, setTabIndex] = useState(0);
  const { searchResults: clientes, loadregistros } = useBuscaClientes([]);

  useEffect(() => {
    if (isOpen) {
      const idrede = secureStorage.getItem('id_r');
      if (idrede) loadregistros(idrede);

      if (produto && produto._id) {
        setProdutoState({
          _id: produto._id?.$oid || produto._id || null,
          gtin: produto.gtin ?? '',
          thumbnail: produto.thumbnail ?? '',
          description: produto.description ?? '',
          price: produto.price ?? '',
          avg_price: produto.avg_price ?? '',
          max_price: produto.max_price ?? '',
          min_price: produto.min_price ?? '',
          width: produto.width ?? '',
          height: produto.height ?? '',
          length: produto.length ?? '',
          net_weight: produto.net_weight ?? '',
          gross_weight: produto.gross_weight ?? '',
          id_Cliente: Array.isArray(produto.id_Cliente) ? produto.id_Cliente.map(String) : [],
          brand: {
            name: produto.brand?.name ?? '',
            picture: produto.brand?.picture ?? ''
          },
          gpc: {
            code: produto.gpc?.code ?? '',
            description: produto.gpc?.description ?? ''
          },
          ncm: {
            code: produto.ncm?.code ?? '',
            description: produto.ncm?.description ?? '',
            full_description: produto.ncm?.full_description ?? ''
          },
          cest: {
            id: produto.cest?.id ?? '',
            code: produto.cest?.code ?? '',
            description: produto.cest?.description ?? '',
            parent_id: produto.cest?.parent_id ?? ''
          },
          gtins: produto.gtins ?? []
        });
      } else {
        // Cadastro novo
        setProdutoState(getProdutoInicial());
      }
    }
  }, [isOpen, produto]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProdutoState((prev) => ({ ...prev, [name]: reader.result }));
      };
      if (files[0]) reader.readAsDataURL(files[0]);
    } else {
      setProdutoState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleNestedChange = (e) => {
    const { name, value, type, files } = e.target;
    const [key, subkey] = name.split('.');
    if (type === 'file') {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProdutoState((prev) => ({
          ...prev,
          [key]: {
            ...prev[key],
            [subkey]: reader.result
          }
        }));
      };
      if (files[0]) reader.readAsDataURL(files[0]);
    } else {
      setProdutoState((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          [subkey]: value
        }
      }));
    }
  };

  const handleKeyPress = async (e) => {
    if (e.key === 'Enter' && produtoState.gtin.length >= 8) {
      e.preventDefault();
      try {
        const data = await buscaProdutoPorGTIN(produtoState.gtin);
        setProdutoState((prev) => ({
          ...prev,
          _id: null, // Força novo cadastro mesmo se a API retornar _id
          ...data,
          ncm: {
            code: data?.ncm?.code || '',
            description: data?.ncm?.description || '',
            full_description: data?.ncm?.full_description || ''
          },
          brand: {
            name: data?.brand?.name || '',
            picture: data?.brand?.picture || ''
          },
          gpc: {
            code: data?.gpc?.code || '',
            description: data?.gpc?.description || ''
          },
          cest: {
            id: data?.cest?.id || '',
            code: data?.cest?.code || '',
            description: data?.cest?.description || '',
            parent_id: data?.cest?.parent_id || ''
          }
        }));
      } catch (err) {
        console.error('Produto não encontrado no Cosmos.');
      }
    }
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...produtoState,
        id_rede: secureStorage.getItem("id_r"),
        id_Cliente: produtoState.id_Cliente.map(String),
        gtins: Array.isArray(produtoState.gtins) ? produtoState.gtins : []
      };

      // Se o produto veio da API e não foi salvo ainda, _id virá preenchido incorretamente
      if (produto?._id === undefined && produtoState._id && typeof produtoState._id === 'string' && produtoState._id.length === 24) {
        // produtoState._id veio do cosmos, remover para forçar POST
        payload._id = null;
      }

      console.log("Enviando produto para salvar:", payload);
      const novoProduto = await ProdutoService.saveProduto(payload);
      atualizarLista();
      setProdutoState(getProdutoInicial());
      onClose();
    } catch (err) {
      console.error('Erro ao salvar produto:', err);
    }
  };

  if (!isOpen) return null;

  return (
    <S.Overlay>
      <S.ModalContainer>
      <S.Title>{produtoState._id ? 'Atualizar Produto' : 'Cadastrar Produto'}</S.Title>

        <Tabs selectedIndex={tabIndex} onSelect={setTabIndex}>
          <S.StyledTabList>
            <S.StyledTab>Produto</S.StyledTab>
            <S.StyledTab>Marca</S.StyledTab>
            <S.StyledTab>GPC</S.StyledTab>
            <S.StyledTab>NCM</S.StyledTab>
            <S.StyledTab>CEST</S.StyledTab>
            <S.StyledTab>GTINs</S.StyledTab>
          </S.StyledTabList>

          <TabPanel>
            <S.InputGroup style={{ display: 'flex', gap: '20px' }}>
              <div style={{ flex: 1 }}>
                <S.Label>GTIN:</S.Label>
                <S.Input name="gtin" value={produtoState.gtin} onChange={handleChange} onKeyDown={handleKeyPress} />

                <S.Label>Descrição:</S.Label>
                <S.Input name="description" value={produtoState.description} onChange={handleChange} />

                <S.Label>Preço:</S.Label>
                <S.Input name="price" value={produtoState.price} onChange={handleChange} />

                <S.Label>Preço Médio:</S.Label>
                <S.Input name="avg_price" value={produtoState.avg_price} onChange={handleChange} />

                <S.Label>Preço Máximo:</S.Label>
                <S.Input name="max_price" value={produtoState.max_price} onChange={handleChange} />

                <S.Label>Preço Mínimo:</S.Label>
                <S.Input name="min_price" value={produtoState.min_price} onChange={handleChange} />

                <S.Label>Largura:</S.Label>
                <S.Input name="width" value={produtoState.width} onChange={handleChange} />

                <S.Label>Altura:</S.Label>
                <S.Input name="height" value={produtoState.height} onChange={handleChange} />

                <S.Label>Comprimento:</S.Label>
                <S.Input name="length" value={produtoState.length} onChange={handleChange} />

                <S.Label>Peso Líquido:</S.Label>
                <S.Input name="net_weight" value={produtoState.net_weight} onChange={handleChange} />

                <S.Label>Peso Bruto:</S.Label>
                <S.Input name="gross_weight" value={produtoState.gross_weight} onChange={handleChange} />
              </div>

              <div style={{ flex: 1 }}>
                <S.Label>Imagem:</S.Label>
                <S.Input type="file" name="thumbnail" onChange={handleChange} />
                {produtoState.thumbnail && <S.ImagePreview src={produtoState.thumbnail} alt="Produto" />}

                <S.Label>Descrição Completa NCM:</S.Label>
                <S.Input
                  name="ncm.full_description"
                  value={produtoState.ncm.full_description}
                  onChange={handleNestedChange}
                  as="textarea"
                  rows={10}
                />
              </div>
            </S.InputGroup>
          </TabPanel>

          <TabPanel>
            <S.InputGroup>
              <S.Label>Cliente:</S.Label>
              <S.Select
                value={produtoState.id_Cliente[0] || ''}
                onChange={(e) =>
                  setProdutoState((prev) => ({ ...prev, id_Cliente: [e.target.value] }))
                }
              >
                <option value="">Selecionar</option>
                {clientes.map((cliente) => (
                  <option key={cliente._id.$oid} value={cliente._id.$oid}>
                    {cliente.nome}
                  </option>
                ))}
              </S.Select>

              <S.Label>Marca:</S.Label>
              <S.Input
                name="brand.name"
                value={produtoState.brand.name}
                onChange={handleNestedChange}
              />

              <S.Label>Imagem Marca:</S.Label>
              <S.Input type="file" name="brand.picture" onChange={handleNestedChange} />
              {produtoState.brand.picture && (
                <S.ImagePreview src={produtoState.brand.picture} alt="Marca" />
              )}
            </S.InputGroup>
          </TabPanel>

          <TabPanel>
            <S.InputGroup>
              <S.Label>Código GPC:</S.Label>
              <S.Input name="gpc.code" value={produtoState.gpc.code} onChange={handleNestedChange} />

              <S.Label>Descrição GPC:</S.Label>
              <S.Input
                name="gpc.description"
                value={produtoState.gpc.description}
                onChange={handleNestedChange}
              />
            </S.InputGroup>
          </TabPanel>

          <TabPanel>
            <S.InputGroup>
              <S.Label>Código NCM:</S.Label>
              <S.Input name="ncm.code" value={produtoState.ncm.code} onChange={handleNestedChange} />

              <S.Label>Descrição NCM:</S.Label>
              <S.Input
                name="ncm.description"
                value={produtoState.ncm.description}
                onChange={handleNestedChange}
              />
            </S.InputGroup>
          </TabPanel>

          <TabPanel>
            <S.InputGroup>
              <S.Label>ID CEST:</S.Label>
              <S.Input name="cest.id" value={produtoState.cest.id} onChange={handleNestedChange} />

              <S.Label>Código CEST:</S.Label>
              <S.Input name="cest.code" value={produtoState.cest.code} onChange={handleNestedChange} />

              <S.Label>Descrição CEST:</S.Label>
              <S.Input
                name="cest.description"
                value={produtoState.cest.description}
                onChange={handleNestedChange}
              />

              <S.Label>ID Pai CEST:</S.Label>
              <S.Input
                name="cest.parent_id"
                value={produtoState.cest.parent_id}
                onChange={handleNestedChange}
              />
            </S.InputGroup>
          </TabPanel>

          <TabPanel>
            <GtinTable
              gtins={produtoState.gtins}
              setGtins={(gtins) => setProdutoState((prev) => ({ ...prev, gtins }))}
            />
          </TabPanel>
        </Tabs>

        <S.ButtonGroup>
          <S.Button onClick={handleSubmit}>
            {produtoState._id ? 'Atualizar' : 'Salvar'}
          </S.Button>
          <S.Button onClick={() => {
            setProdutoState(getProdutoInicial());
            setTabIndex(0);
            onClose();
          }}>Cancelar</S.Button>
        </S.ButtonGroup>
      </S.ModalContainer>
    </S.Overlay>
  );
};

export default ModalCadastroProduto;
